import {lazy} from '@aboutyou/lazy-imports';

export const SettingsModal = lazy(() =>
  import('./SettingsModal.eager').then(mod => ({default: mod.SettingsModal})),
);
